/* eslint-disable max-len */
import cn from 'classnames';
import { ArrowSVGProps } from '../types/types';

export const HeaderAuthIcon = () => {
    return (
        <svg
            width="26"
            height="27"
            viewBox="0 0 26 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M13 13.5229C14.6908 13.5229 16.3123 12.8513 17.5078 11.6558C18.7034 10.4602 19.375 8.8387 19.375 7.14795C19.375 5.45719 18.7034 3.83569 17.5078 2.64014C16.3123 1.4446 14.6908 0.772949 13 0.772949C11.3092 0.772949 9.68774 1.4446 8.49219 2.64014C7.29665 3.83569 6.625 5.45719 6.625 7.14795C6.625 8.8387 7.29665 10.4602 8.49219 11.6558C9.68774 12.8513 11.3092 13.5229 13 13.5229ZM17.25 7.14795C17.25 8.27512 16.8022 9.35612 16.0052 10.1532C15.2082 10.9502 14.1272 11.3979 13 11.3979C11.8728 11.3979 10.7918 10.9502 9.9948 10.1532C9.19777 9.35612 8.75 8.27512 8.75 7.14795C8.75 6.02078 9.19777 4.93977 9.9948 4.14275C10.7918 3.34572 11.8728 2.89795 13 2.89795C14.1272 2.89795 15.2082 3.34572 16.0052 4.14275C16.8022 4.93977 17.25 6.02078 17.25 7.14795ZM25.75 24.1479C25.75 26.2729 23.625 26.2729 23.625 26.2729H2.375C2.375 26.2729 0.25 26.2729 0.25 24.1479C0.25 22.0229 2.375 15.6479 13 15.6479C23.625 15.6479 25.75 22.0229 25.75 24.1479ZM23.625 24.1395C23.6229 23.6167 23.2978 22.0442 21.857 20.6034C20.4715 19.2179 17.8641 17.7729 13 17.7729C8.13375 17.7729 5.5285 19.2179 4.143 20.6034C2.70225 22.0442 2.37925 23.6167 2.375 24.1395H23.625Z"
                fill="black"
            />
        </svg>
    );
};

export const RightArrowIcon = ({ className }: ArrowSVGProps) => {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.52742 7.24058L1.35242 7.24059C1.06908 7.24059 0.831417 7.14459 0.639417 6.95259C0.448084 6.76125 0.352417 6.52392 0.352417 6.24059C0.352417 5.95725 0.448084 5.71958 0.639417 5.52759C0.831417 5.33625 1.06908 5.24059 1.35242 5.24059L8.52742 5.24058L5.65242 2.34059C5.46908 2.15725 5.37308 1.92825 5.36442 1.65359C5.35642 1.37825 5.45242 1.14059 5.65242 0.940586C5.83575 0.757252 6.06908 0.665584 6.35242 0.665584C6.63575 0.665584 6.86908 0.757252 7.05242 0.940586L11.6524 5.54059C11.8524 5.74058 11.9524 5.97392 11.9524 6.24058C11.9524 6.50725 11.8524 6.74058 11.6524 6.94058L7.05242 11.5406C6.86908 11.7239 6.63975 11.8196 6.36442 11.8276C6.08975 11.8363 5.85242 11.7406 5.65242 11.5406C5.46908 11.3573 5.37742 11.1239 5.37742 10.8406C5.37742 10.5573 5.46908 10.3239 5.65242 10.1406L8.52742 7.24058Z"
                fill="black"
                className={className}
            />
        </svg>
    );
};

export const LeftArrowIcon = ({ className }: ArrowSVGProps) => {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.42501 4.58754L10.6 4.58754C10.8833 4.58754 11.121 4.68354 11.313 4.87554C11.5043 5.06687 11.6 5.30421 11.6 5.58754C11.6 5.87087 11.5043 6.10854 11.313 6.30054C11.121 6.49187 10.8833 6.58754 10.6 6.58754L3.42501 6.58754L6.30001 9.48754C6.48334 9.67087 6.57934 9.89987 6.58801 10.1745C6.59601 10.4499 6.50001 10.6875 6.30001 10.8875C6.11667 11.0709 5.88334 11.1625 5.60001 11.1625C5.31667 11.1625 5.08334 11.0709 4.90001 10.8875L0.300007 6.28754C0.100007 6.08754 5.46615e-06 5.85421 5.47781e-06 5.58754C5.48946e-06 5.32087 0.100007 5.08754 0.300007 4.88754L4.90001 0.287539C5.08334 0.104206 5.31267 0.00853966 5.58801 0.000539675C5.86267 -0.00812698 6.10001 0.0875394 6.30001 0.287539C6.48334 0.470873 6.57501 0.704206 6.57501 0.98754C6.57501 1.27087 6.48334 1.50421 6.30001 1.68754L3.42501 4.58754Z"
                fill="black"
                className={className}
            />
        </svg>
    );
};

export const VkIcon = () => {
    return (
        <svg
            width="48"
            height="46"
            viewBox="0 0 48 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M23.9955 0.239868C11.2768 0.239868 0.966431 10.3308 0.966431 22.779C0.966431 35.2272 11.2768 45.3181 23.9955 45.3181C36.7143 45.3181 47.0246 35.2272 47.0246 22.779C47.0246 10.3308 36.7143 0.239868 23.9955 0.239868ZM32.8521 25.6692C32.8521 25.6692 34.8888 27.6366 35.3901 28.5499C35.4045 28.5687 35.4117 28.5875 35.4165 28.5969C35.6204 28.9326 35.6684 29.1932 35.5677 29.3881C35.3997 29.7121 34.824 29.8718 34.6273 29.8859H31.029C30.7795 29.8859 30.2566 29.8225 29.6233 29.3952C29.1363 29.0618 28.6565 28.5147 28.1888 27.9818C27.4907 27.1882 26.8862 26.5026 26.2769 26.5026C26.1995 26.5025 26.1225 26.5144 26.049 26.5379C25.5884 26.6834 24.9983 27.3267 24.9983 29.0406C24.9983 29.5759 24.5665 29.8835 24.2618 29.8835H22.6138C22.0525 29.8835 19.1282 29.691 16.5375 27.0168C13.3662 23.7416 10.5115 17.1724 10.4875 17.1113C10.3076 16.6864 10.6794 16.4586 11.0848 16.4586H14.7191C15.2037 16.4586 15.362 16.7474 15.4724 17.0033C15.6019 17.3015 16.0769 18.4872 16.8565 19.8207C18.1207 21.9948 18.8955 22.8776 19.5169 22.8776C19.6334 22.8763 19.7478 22.8473 19.8503 22.7931C20.6611 22.3517 20.51 19.5226 20.474 18.9356C20.474 18.8253 20.4716 17.6701 20.0566 17.116C19.7591 16.7146 19.253 16.5619 18.9459 16.5056C19.0702 16.3378 19.2339 16.2017 19.4233 16.1088C19.9798 15.8365 20.9826 15.7966 21.9781 15.7966H22.5322C23.6117 15.8106 23.89 15.8787 24.281 15.975C25.0726 16.1605 25.0894 16.6606 25.0199 18.3721C24.9983 18.8581 24.9767 19.4075 24.9767 20.0555C24.9767 20.1964 24.9695 20.3466 24.9695 20.5063C24.9455 21.3773 24.9167 22.3658 25.5452 22.7719C25.6272 22.8223 25.7219 22.8491 25.8187 22.8494C26.037 22.8494 26.6943 22.8494 28.4742 19.8606C29.0232 18.8986 29.5002 17.899 29.9015 16.8695C29.9375 16.8085 30.0431 16.6206 30.1678 16.5479C30.2599 16.5019 30.3619 16.4786 30.4653 16.4798H34.7377C35.203 16.4798 35.5221 16.5479 35.5821 16.7239C35.6876 17.0033 35.5629 17.8556 33.6126 20.4406L32.7418 21.5652C30.9738 23.8332 30.9738 23.9482 32.8521 25.6692Z"
                fill="#9797A8"
            />
        </svg>
    );
};

export const TgIcon = () => {
    return (
        <svg
            width="46"
            height="46"
            viewBox="0 0 46 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M22.5638 0.239868C10.1222 0.239868 0.0246582 10.3374 0.0246582 22.779C0.0246582 35.2206 10.1222 45.3181 22.5638 45.3181C35.0054 45.3181 45.1029 35.2206 45.1029 22.779C45.1029 10.3374 35.0054 0.239868 22.5638 0.239868ZM33.022 15.5665C32.6839 19.1277 31.2188 27.7827 30.475 31.7721C30.1595 33.4626 29.5284 34.026 28.9424 34.0937C27.6351 34.2064 26.6434 33.2372 25.3812 32.4032C23.3977 31.096 22.2708 30.2845 20.355 29.0224C18.1236 27.5573 19.5661 26.7459 20.8508 25.4386C21.1889 25.1005 26.9589 19.8489 27.0716 19.3756C27.0873 19.3039 27.0852 19.2295 27.0656 19.1588C27.0459 19.0881 27.0093 19.0232 26.9589 18.9699C26.8237 18.8572 26.6434 18.9023 26.4856 18.9248C26.2828 18.9699 23.1273 21.066 16.9741 25.2132C16.0725 25.8218 15.2611 26.1373 14.5399 26.1148C13.7285 26.0923 12.1958 25.664 11.0463 25.2809C9.62633 24.8301 8.52191 24.5821 8.61207 23.7933C8.65715 23.3876 9.22063 22.9819 10.28 22.5536C16.8614 19.6911 21.234 17.7979 23.4203 16.8963C29.6862 14.2818 30.9709 13.831 31.8274 13.831C32.0077 13.831 32.4359 13.876 32.7064 14.1014C32.9318 14.2818 32.9994 14.5297 33.022 14.71C32.9994 14.8452 33.0445 15.2509 33.022 15.5665Z"
                fill="#9797A8"
            />
        </svg>
    );
};

export const CheckMarkIcon = () => {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5.22144 7.05792L3.95269 5.78917C3.84575 5.68223 3.71216 5.63129 3.55194 5.63634C3.39133 5.64101 3.25755 5.69681 3.15061 5.80376C3.04366 5.9107 2.99019 6.04681 2.99019 6.21209C2.99019 6.37737 3.04366 6.51348 3.15061 6.62042L4.81311 8.28292C4.92005 8.38987 5.05616 8.44334 5.22144 8.44334C5.38672 8.44334 5.52283 8.38987 5.62977 8.28292L8.94019 4.97251C9.04714 4.86556 9.09827 4.73179 9.09361 4.57117C9.08855 4.41095 9.03255 4.27737 8.92561 4.17042C8.81866 4.06348 8.68255 4.01001 8.51727 4.01001C8.352 4.01001 8.21589 4.06348 8.10894 4.17042L5.22144 7.05792ZM6.03811 11.8413C5.23116 11.8413 4.47283 11.688 3.76311 11.3816C3.05338 11.0755 2.43602 10.66 1.91102 10.135C1.38602 9.61001 0.970495 8.99265 0.66444 8.28292C0.357995 7.5732 0.204773 6.81487 0.204773 6.00793C0.204773 5.20098 0.357995 4.44265 0.66444 3.73292C0.970495 3.0232 1.38602 2.40584 1.91102 1.88084C2.43602 1.35584 3.05338 0.940119 3.76311 0.633674C4.47283 0.327619 5.23116 0.174591 6.03811 0.174591C6.84505 0.174591 7.60338 0.327619 8.31311 0.633674C9.02283 0.940119 9.64019 1.35584 10.1652 1.88084C10.6902 2.40584 11.1057 3.0232 11.4118 3.73292C11.7182 4.44265 11.8714 5.20098 11.8714 6.00793C11.8714 6.81487 11.7182 7.5732 11.4118 8.28292C11.1057 8.99265 10.6902 9.61001 10.1652 10.135C9.64019 10.66 9.02283 11.0755 8.31311 11.3816C7.60338 11.688 6.84505 11.8413 6.03811 11.8413ZM6.03811 10.6746C7.33116 10.6746 8.4323 10.2202 9.34152 9.31134C10.2504 8.40212 10.7048 7.30098 10.7048 6.00793C10.7048 4.71487 10.2504 3.61373 9.34152 2.70451C8.4323 1.79567 7.33116 1.34126 6.03811 1.34126C4.74505 1.34126 3.64411 1.79567 2.73527 2.70451C1.82605 3.61373 1.37144 4.71487 1.37144 6.00793C1.37144 7.30098 1.82605 8.40212 2.73527 9.31134C3.64411 10.2202 4.74505 10.6746 6.03811 10.6746Z"
                fill="#6C6C6C"
            />
        </svg>
    );
};

export const LikeIcon = ({ className, onClick }: LikeIconProps) => {
    return (
        <svg
            className={className}
            onClick={onClick}
            width="20"
            height="19"
            viewBox="0 0 20 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.88659 16.7279L8.88587 16.7272C6.30104 14.3833 4.19578 12.4709 2.73088 10.6787C1.27148 8.89322 0.5 7.28825 0.5 5.56763C0.5 2.75436 2.69555 0.567627 5.5 0.567627C7.08885 0.567627 8.62206 1.30986 9.62058 2.47327L10 2.91534L10.3794 2.47327C11.3779 1.30986 12.9112 0.567627 14.5 0.567627C17.3045 0.567627 19.5 2.75436 19.5 5.56763C19.5 7.28825 18.7285 8.89322 17.2691 10.6787C15.8042 12.4709 13.699 14.3833 11.1141 16.7272L11.1134 16.7279L10 17.7415L8.88659 16.7279Z"
                stroke="#555454"
            />
        </svg>
    );
};

interface LikeIconProps {
    className?: string;
    onClick?: () => void;
}

export const LocationMarkIcon = () => {
    return (
        <svg
            width="12"
            height="14"
            viewBox="0 0 12 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6.04615 7.09065C6.41281 7.09065 6.72681 6.95999 6.98815 6.69865C7.24904 6.43777 7.37948 6.12399 7.37948 5.75732C7.37948 5.39065 7.24904 5.07665 6.98815 4.81532C6.72681 4.55443 6.41281 4.42399 6.04615 4.42399C5.67948 4.42399 5.3657 4.55443 5.10481 4.81532C4.84348 5.07665 4.71281 5.39065 4.71281 5.75732C4.71281 6.12399 4.84348 6.43777 5.10481 6.69865C5.3657 6.95999 5.67948 7.09065 6.04615 7.09065ZM6.04615 11.9907C7.4017 10.7462 8.40726 9.61554 9.06281 8.59865C9.71837 7.58221 10.0461 6.67954 10.0461 5.89065C10.0461 4.67954 9.65993 3.68777 8.88748 2.91532C8.11548 2.14332 7.16837 1.75732 6.04615 1.75732C4.92393 1.75732 3.97659 2.14332 3.20415 2.91532C2.43215 3.68777 2.04615 4.67954 2.04615 5.89065C2.04615 6.67954 2.37393 7.58221 3.02948 8.59865C3.68504 9.61554 4.69059 10.7462 6.04615 11.9907ZM6.04615 13.7573C4.25726 12.2351 2.92126 10.8211 2.03815 9.51532C1.15459 8.20999 0.712814 7.00177 0.712814 5.89065C0.712814 4.22399 1.24904 2.89621 2.32148 1.90732C3.39348 0.918433 4.63504 0.423988 6.04615 0.423988C7.45726 0.423988 8.69881 0.918433 9.77081 1.90732C10.8433 2.89621 11.3795 4.22399 11.3795 5.89065C11.3795 7.00177 10.9379 8.20999 10.0548 9.51532C9.17126 10.8211 7.83504 12.2351 6.04615 13.7573Z"
                fill="#555454"
            />
        </svg>
    );
};

export const LeftArrow = () => {
    return (
        <svg
            className=""
            width="11"
            height="19"
            viewBox="0 0 11 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0.413527 9.51691C0.413527 9.31135 0.45207 9.11248 0.529153 8.92028C0.606236 8.72706 0.709014 8.56621 0.837486 8.43774L7.92915 1.34607C8.21179 1.06344 8.57151 0.922116 9.00832 0.922116C9.44513 0.922116 9.80485 1.06344 10.0875 1.34607C10.3701 1.62871 10.5114 1.98844 10.5114 2.42524C10.5114 2.86205 10.3701 3.22177 10.0875 3.50441L4.07499 9.51691L10.0875 15.5294C10.3701 15.812 10.5114 16.1718 10.5114 16.6086C10.5114 17.0454 10.3701 17.4051 10.0875 17.6877C9.80485 17.9704 9.44512 18.1117 9.00832 18.1117C8.57151 18.1117 8.21179 17.9704 7.92915 17.6877L0.837486 10.5961C0.68332 10.4419 0.574376 10.2749 0.510653 10.095C0.445903 9.91517 0.413527 9.72246 0.413527 9.51691Z"
                fill="#4F52FF"
                // fill-opacity="0.44"
            />
        </svg>
    );
};

export const RightArrow = () => {
    return (
        <svg
            width="11"
            height="19"
            viewBox="0 0 11 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.5865 9.51697C10.5865 9.72252 10.5479 9.9214 10.4708 10.1136C10.3938 10.3068 10.291 10.4677 10.1625 10.5961L3.07085 17.6878C2.78821 17.9704 2.42849 18.1118 1.99168 18.1118C1.55487 18.1118 1.19515 17.9704 0.912514 17.6878C0.629875 17.4052 0.488556 17.0454 0.488556 16.6086C0.488556 16.1718 0.629875 15.8121 0.912514 15.5295L6.92501 9.51697L0.912513 3.50447C0.629874 3.22183 0.488555 2.86211 0.488555 2.4253C0.488555 1.98849 0.629874 1.62877 0.912513 1.34613C1.19515 1.0635 1.55487 0.922174 1.99168 0.922174C2.42848 0.922174 2.78821 1.0635 3.07085 1.34613L10.1625 8.4378C10.3167 8.59197 10.4256 8.75898 10.4893 8.93884C10.5541 9.1187 10.5865 9.31141 10.5865 9.51697Z"
                fill="#4F52FF"
            />
        </svg>
    );
};

export const RightVector = () => {
    return (
        <svg
            width="5"
            height="7"
            viewBox="0 0 5 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.3275 3.50003C4.3275 3.56893 4.31458 3.63558 4.28875 3.7C4.26291 3.76476 4.22846 3.81867 4.1854 3.86173L1.8085 6.23864C1.71377 6.33337 1.5932 6.38074 1.44679 6.38074C1.30039 6.38074 1.17982 6.33337 1.08509 6.23864C0.990359 6.14391 0.942993 6.02334 0.942993 5.87694C0.942993 5.73053 0.990359 5.60997 1.08509 5.51523L3.10029 3.50003L1.08509 1.48483C0.990359 1.3901 0.942993 1.26953 0.942993 1.12313C0.942993 0.976723 0.990359 0.856156 1.08509 0.761424C1.17982 0.666692 1.30039 0.619326 1.44679 0.619326C1.5932 0.619326 1.71376 0.666692 1.8085 0.761424L4.1854 3.13833C4.23707 3.19 4.27359 3.24598 4.29495 3.30626C4.31665 3.36655 4.3275 3.43114 4.3275 3.50003Z"
                fill="#6C6C6C"
            />
        </svg>
    );
};

export const PaginationRightVector = ({
    className,
    onClick,
}: ActiveButtonProps) => {
    return (
        <svg
            onClick={onClick}
            className={className}
            width="11"
            height="18"
            viewBox="0 0 11 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.814 9.40521C10.814 9.61076 10.7754 9.80964 10.6984 10.0018C10.6213 10.1951 10.5185 10.3559 10.39 10.4844L3.29836 17.576C3.01572 17.8587 2.65599 18 2.21919 18C1.78238 18 1.42266 17.8587 1.14002 17.576C0.857383 17.2934 0.716064 16.9337 0.716064 16.4969C0.716064 16.0601 0.857383 15.7003 1.14002 15.4177L7.15252 9.40521L1.14002 3.39271C0.857383 3.11007 0.716065 2.75035 0.716065 2.31354C0.716065 1.87674 0.857383 1.51702 1.14002 1.23438C1.42266 0.951736 1.78238 0.810415 2.21919 0.810415C2.65599 0.810415 3.01572 0.951736 3.29836 1.23438L10.39 8.32604C10.5442 8.48021 10.6531 8.64722 10.7169 8.82708C10.7816 9.00694 10.814 9.19965 10.814 9.40521Z"
                fill="#555454"
            />
        </svg>
    );
};

export const PaginationLeftVector = ({
    className,
    onClick,
}: ActiveButtonProps) => {
    return (
        <svg
            className={className}
            onClick={onClick}
            width="11"
            height="19"
            viewBox="0 0 11 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0.0497881 9.58356C0.0497881 9.37801 0.0883309 9.17913 0.165414 8.98694C0.242497 8.79371 0.345275 8.63287 0.473747 8.50439L7.56541 1.41273C7.84805 1.13009 8.20778 0.988769 8.64458 0.988769C9.08139 0.988769 9.44111 1.13009 9.72375 1.41273C10.0064 1.69537 10.1477 2.05509 10.1477 2.49189C10.1477 2.9287 10.0064 3.28842 9.72375 3.57106L3.71125 9.58356L9.72375 15.5961C10.0064 15.8787 10.1477 16.2384 10.1477 16.6752C10.1477 17.112 10.0064 17.4718 9.72375 17.7544C9.44111 18.037 9.08139 18.1784 8.64458 18.1784C8.20777 18.1784 7.84805 18.037 7.56541 17.7544L0.473747 10.6627C0.319581 10.5086 0.210637 10.3415 0.146914 10.1617C0.0821644 9.98182 0.0497881 9.78912 0.0497881 9.58356Z"
                fill={'#555454'}
            />
        </svg>
    );
};

export const LinkIcon = () => {
    return (
        <svg
            width="24"
            height="20"
            viewBox="0 0 24 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M19.875 19.0969C19.875 19.329 19.7828 19.5515 19.6187 19.7156C19.4546 19.8797 19.2321 19.9719 19 19.9719H2.375C1.91087 19.9719 1.46575 19.7875 1.13756 19.4593C0.809374 19.1311 0.625 18.686 0.625 18.2219V5.09689C0.625 4.86483 0.717187 4.64227 0.881282 4.47817C1.04538 4.31408 1.26794 4.22189 1.5 4.22189C1.73206 4.22189 1.95462 4.31408 2.11872 4.47817C2.28281 4.64227 2.375 4.86483 2.375 5.09689V18.2219H19C19.2321 18.2219 19.4546 18.3141 19.6187 18.4782C19.7828 18.6423 19.875 18.8648 19.875 19.0969ZM23.1781 7.4047C23.1894 7.3925 23.197 7.37732 23.2 7.36095L23.2219 7.32814L23.2547 7.29533L23.2766 7.26252C23.2766 7.24064 23.2875 7.2297 23.2875 7.21877L23.3094 7.18595C23.3094 7.16408 23.3203 7.15314 23.3203 7.1422L23.3422 7.09845C23.3419 7.08317 23.3457 7.06808 23.3531 7.0547V7.02189C23.362 7.0051 23.3658 6.98611 23.3641 6.9672C23.3636 6.96128 23.3643 6.95531 23.3662 6.94967C23.368 6.94403 23.371 6.93883 23.375 6.93439V6.75939C23.371 6.75495 23.368 6.74975 23.3662 6.74411C23.3643 6.73847 23.3636 6.7325 23.3641 6.72658C23.3658 6.70768 23.362 6.68868 23.3531 6.67189V6.63908C23.3457 6.6257 23.3419 6.61062 23.3422 6.59533L23.3203 6.55158C23.3203 6.54064 23.3094 6.5297 23.3094 6.50783L23.2875 6.47502C23.2875 6.46408 23.2766 6.45314 23.2766 6.43127L23.2547 6.39845L23.2219 6.36564L23.2 6.33283C23.197 6.31646 23.1894 6.30129 23.1781 6.28908C23.1672 6.27814 23.1453 6.2672 23.1344 6.24533C23.128 6.23972 23.1241 6.23188 23.1234 6.22345L17.8734 0.973453C17.7034 0.833923 17.4876 0.762617 17.2679 0.773406C17.0483 0.784195 16.8405 0.876307 16.6849 1.03182C16.5294 1.18734 16.4373 1.39515 16.4265 1.61482C16.4157 1.83449 16.487 2.05032 16.6266 2.22033L20.3891 5.97189H16.375C13.8527 5.96995 11.4014 6.80722 9.40733 8.35179C7.41324 9.89636 5.98969 12.0605 5.36094 14.5031C5.30426 14.7264 5.33793 14.9631 5.45465 15.1617C5.57137 15.3603 5.76172 15.5049 5.98438 15.5641L6.20312 15.5969C6.39765 15.5963 6.58658 15.5318 6.74077 15.4132C6.89495 15.2946 7.00582 15.1285 7.05625 14.9406C7.58798 12.8737 8.79232 11.0425 10.4795 9.73556C12.1667 8.42858 14.2408 7.72015 16.375 7.72189H20.3891L16.6266 11.4735C16.4623 11.6393 16.3701 11.8634 16.3701 12.0969C16.3701 12.3304 16.4623 12.5544 16.6266 12.7203C16.7938 12.882 17.0174 12.9724 17.25 12.9724C17.4826 12.9724 17.7062 12.882 17.8734 12.7203L23.1234 7.47033C23.1241 7.4619 23.128 7.45406 23.1344 7.44845C23.1453 7.42658 23.1672 7.41564 23.1781 7.4047Z"
                fill="#555454"
            />
        </svg>
    );
};

export const SearchIcon = () => {
    return (
        <svg
            width="29"
            height="28"
            viewBox="0 0 29 28"
            fill="#6C6C6C"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11.5 9C11.5 8.44772 11.9477 8 12.5 8C14.7091 8 16.5 9.79086 16.5 12C16.5 12.5523 16.0523 13 15.5 13C14.9477 13 14.5 12.5523 14.5 12C14.5 10.8954 13.6046 10 12.5 10C11.9477 10 11.5 9.55228 11.5 9Z"
                fill="#6C6C6C"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.5 12C4.5 7.58172 8.08172 4 12.5 4C16.9183 4 20.5 7.58172 20.5 12C20.5 13.8487 19.8729 15.551 18.8199 16.9056L23.2071 21.2929C23.5976 21.6834 23.5976 22.3166 23.2071 22.7071C22.8166 23.0976 22.1834 23.0976 21.7929 22.7071L17.4056 18.3199C16.051 19.3729 14.3487 20 12.5 20C8.08172 20 4.5 16.4183 4.5 12ZM12.5 6C9.18629 6 6.5 8.68629 6.5 12C6.5 15.3137 9.18629 18 12.5 18C15.8137 18 18.5 15.3137 18.5 12C18.5 8.68629 15.8137 6 12.5 6Z"
                fill="#6C6C6C"
            />
        </svg>
    );
};

export const CheckMark = ({ onClick }: ActiveButtonProps) => {
    return (
        <svg
            onClick={onClick}
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6.4987 7.5988C6.35981 7.5988 6.22543 7.57275 6.09557 7.52067C5.96502 7.46859 5.85634 7.39914 5.76953 7.31234L0.977864 2.52067C0.786892 2.3297 0.691406 2.08664 0.691406 1.7915C0.691406 1.49636 0.786892 1.25331 0.977864 1.06234C1.16884 0.871365 1.41189 0.775879 1.70703 0.775879C2.00217 0.775879 2.24523 0.871365 2.4362 1.06234L6.4987 5.12484L10.5612 1.06234C10.7522 0.871365 10.9952 0.775879 11.2904 0.775879C11.5855 0.775879 11.8286 0.871365 12.0195 1.06234C12.2105 1.25331 12.306 1.49636 12.306 1.7915C12.306 2.08664 12.2105 2.3297 12.0195 2.52067L7.22786 7.31234C7.1237 7.4165 7.01085 7.49011 6.88932 7.53317C6.76779 7.57692 6.63759 7.5988 6.4987 7.5988Z"
                fill="black"
            />
        </svg>
    );
};

//aside navigation icons

export const AsideSupportIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.63753 6C7.4284 6 5.63753 7.79086 5.63753 10C5.63753 12.2091 7.4284 14 9.63753 14C11.8467 14 13.6375 12.2091 13.6375 10C13.6375 7.79086 11.8467 6 9.63753 6ZM7.63753 10C7.63753 8.89543 8.53296 8 9.63753 8C10.7421 8 11.6375 8.89543 11.6375 10C11.6375 11.1046 10.7421 12 9.63753 12C8.53296 12 7.63753 11.1046 7.63753 10Z"
                fill="#555454"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.08506 0C7.32074 0 6.67864 0.574706 6.59424 1.33435L6.44673 2.66194C5.88793 2.90521 5.36264 3.21025 4.87941 3.56825L3.65456 3.03161C2.95448 2.72488 2.13573 2.9936 1.75356 3.65552L0.201086 6.34449C-0.181076 7.00642 -0.00441557 7.84984 0.611257 8.30276L1.68825 9.09505C1.65472 9.3924 1.63754 9.69437 1.63754 10C1.63754 10.3056 1.65473 10.6076 1.68825 10.905L0.611257 11.6973C-0.00441593 12.1502 -0.181075 12.9936 0.201086 13.6555L1.75356 16.3445C2.13573 17.0064 2.95448 17.2751 3.65456 16.9684L4.87943 16.4318C5.36265 16.7898 5.88794 17.0948 6.44673 17.3381L6.59424 18.6656C6.67864 19.4253 7.32074 20 8.08506 20H11.19C11.9543 20 12.5964 19.4253 12.6808 18.6656L12.8284 17.3381C13.3872 17.0948 13.9125 16.7897 14.3957 16.4317L15.6206 16.9684C16.3207 17.2751 17.1394 17.0064 17.5216 16.3445L19.0741 13.6555C19.4562 12.9936 19.2796 12.1502 18.6639 11.6973L17.5868 10.9049C17.6204 10.6076 17.6375 10.3056 17.6375 10C17.6375 9.69439 17.6204 9.39244 17.5868 9.09511L18.6639 8.30276C19.2796 7.84984 19.4562 7.00642 19.0741 6.34449L17.5216 3.65552C17.1394 2.9936 16.3207 2.72488 15.6206 3.03161L14.3957 3.56827C13.9125 3.21026 13.3872 2.90522 12.8284 2.66194L12.6808 1.33435C12.5964 0.574704 11.9543 0 11.19 0H8.08506ZM8.40267 3.1692L8.53258 2H10.7425L10.8724 3.1692C10.9376 3.75548 11.3318 4.21692 11.8331 4.41412C12.3925 4.6342 12.9114 4.93624 13.3749 5.30584C13.7966 5.64206 14.3937 5.75269 14.934 5.51596L16.0133 5.04309L17.1183 6.95693L16.1698 7.65469C15.6952 8.0038 15.4925 8.57514 15.5718 9.10754C15.615 9.39819 15.6375 9.69615 15.6375 10C15.6375 10.3039 15.615 10.6018 15.5718 10.8925C15.4925 11.4249 15.6952 11.9962 16.1698 12.3453L17.1183 13.0431L16.0133 14.9569L14.934 14.484C14.3937 14.2473 13.7966 14.3579 13.3749 14.6942C12.9114 15.0638 12.3925 15.3658 11.8331 15.5859C11.3318 15.7831 10.9376 16.2445 10.8724 16.8308L10.7425 18H8.53258L8.40267 16.8308C8.33753 16.2445 7.94324 15.7831 7.442 15.5859C6.88259 15.3658 6.36368 15.0638 5.90019 14.6942C5.47854 14.358 4.88141 14.2473 4.34112 14.4841L3.26186 14.9569L2.1569 13.0431L3.10533 12.3454C3.57989 11.9963 3.78262 11.4249 3.70333 10.8925C3.66005 10.6018 3.63754 10.3039 3.63754 10C3.63754 9.69614 3.66005 9.39816 3.70333 9.1075C3.78261 8.5751 3.57988 8.00375 3.10533 7.65464L2.1569 6.95693L3.26186 5.04309L4.3411 5.51594C4.8814 5.75266 5.47853 5.64204 5.90018 5.30582C6.36367 4.93623 6.88258 4.6342 7.442 4.41412C7.94324 4.21692 8.33753 3.75548 8.40267 3.1692Z"
                fill="#555454"
            />
        </svg>
    );
};

export const AsideAboutIcon = () => {
    return (
        <svg
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7 5C7 4.44772 7.44772 4 8 4C10.2091 4 12 5.79086 12 8C12 8.55228 11.5523 9 11 9C10.4477 9 10 8.55228 10 8C10 6.89543 9.10457 6 8 6C7.44772 6 7 5.55228 7 5Z"
                fill="#555454"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 9.84871 15.3729 11.551 14.3199 12.9056L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12.9056 14.3199C11.551 15.3729 9.84871 16 8 16C3.58172 16 0 12.4183 0 8ZM8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2Z"
                fill="#555454"
            />
        </svg>
    );
};

export const AsideVerificationIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5.5 12C6.32843 12 7 11.3284 7 10.5C7 9.67157 6.32843 9 5.5 9C4.67157 9 4 9.67157 4 10.5C4 11.3284 4.67157 12 5.5 12Z"
                fill="#555454"
            />
            <path
                d="M10 12C10.8284 12 11.5 11.3284 11.5 10.5C11.5 9.67157 10.8284 9 10 9C9.17157 9 8.5 9.67157 8.5 10.5C8.5 11.3284 9.17157 12 10 12Z"
                fill="#555454"
            />
            <path
                d="M16 10.5C16 11.3284 15.3284 12 14.5 12C13.6716 12 13 11.3284 13 10.5C13 9.67157 13.6716 9 14.5 9C15.3284 9 16 9.67157 16 10.5Z"
                fill="#555454"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0ZM2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10Z"
                fill="#555454"
            />
        </svg>
    );
};

export const AsideStudentsIcon = () => {
    return (
        <svg
            width="23"
            height="21"
            viewBox="0 0 23 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.3183 1.24235L1.73978 5.70316C1.01514 6.07997 1.02339 7.11954 1.75392 7.4848L10.3325 11.7741C10.6166 11.9162 10.9513 11.9148 11.2342 11.7705L19.6411 7.48121C20.362 7.11344 20.3702 6.0864 19.6554 5.7071L11.2483 1.24621C10.9578 1.09206 10.6101 1.09061 10.3183 1.24235Z"
                stroke="#555454"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M4.09766 8.76562V15.3005C4.09766 15.6607 4.29131 15.993 4.60464 16.1706L10.0832 19.2751C10.3847 19.4459 10.7532 19.4485 11.0571 19.2819L16.7354 16.168C17.0555 15.9924 17.2545 15.6563 17.2545 15.2912V8.76562"
                stroke="#555454"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M18.9807 8.11719L21.4965 9.55476C21.808 9.7328 22.0003 10.0641 22.0003 10.423V13.9407"
                stroke="#555454"
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    );
};

export const AsidePartnersIcon = () => {
    return (
        <svg
            width="20"
            height="19"
            viewBox="0 0 20 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17 4H14V3C14 2.20435 13.6839 1.44129 13.1213 0.87868C12.5587 0.316071 11.7956 0 11 0H9C8.20435 0 7.44129 0.316071 6.87868 0.87868C6.31607 1.44129 6 2.20435 6 3V4H3C2.20435 4 1.44129 4.31607 0.87868 4.87868C0.316071 5.44129 0 6.20435 0 7V16C0 16.7956 0.316071 17.5587 0.87868 18.1213C1.44129 18.6839 2.20435 19 3 19H17C17.7956 19 18.5587 18.6839 19.1213 18.1213C19.6839 17.5587 20 16.7956 20 16V7C20 6.20435 19.6839 5.44129 19.1213 4.87868C18.5587 4.31607 17.7956 4 17 4ZM8 3C8 2.73478 8.10536 2.48043 8.29289 2.29289C8.48043 2.10536 8.73478 2 9 2H11C11.2652 2 11.5196 2.10536 11.7071 2.29289C11.8946 2.48043 12 2.73478 12 3V4H8V3ZM18 16C18 16.2652 17.8946 16.5196 17.7071 16.7071C17.5196 16.8946 17.2652 17 17 17H3C2.73478 17 2.48043 16.8946 2.29289 16.7071C2.10536 16.5196 2 16.2652 2 16V10.95H5V12C5 12.2652 5.10536 12.5196 5.29289 12.7071C5.48043 12.8946 5.73478 13 6 13C6.26522 13 6.51957 12.8946 6.70711 12.7071C6.89464 12.5196 7 12.2652 7 12V10.95H13V12C13 12.2652 13.1054 12.5196 13.2929 12.7071C13.4804 12.8946 13.7348 13 14 13C14.2652 13 14.5196 12.8946 14.7071 12.7071C14.8946 12.5196 15 12.2652 15 12V10.95H18V16ZM18 9H2V7C2 6.73478 2.10536 6.48043 2.29289 6.29289C2.48043 6.10536 2.73478 6 3 6H17C17.2652 6 17.5196 6.10536 17.7071 6.29289C17.8946 6.48043 18 6.73478 18 7V9Z"
                fill="#555454"
            />
        </svg>
    );
};

export const AsideResumeIcon = () => {
    return (
        <svg
            width="18"
            height="20"
            viewBox="0 0 18 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.5 13.3333C4.5 12.7197 5.00368 12.2222 5.625 12.2222H12.375C12.9963 12.2222 13.5 12.7197 13.5 13.3333C13.5 13.947 12.9963 14.4444 12.375 14.4444H5.625C5.00368 14.4444 4.5 13.947 4.5 13.3333Z"
                fill="#555454"
            />
            <path
                d="M5.625 7.77778C5.00368 7.77778 4.5 8.27524 4.5 8.88889C4.5 9.50254 5.00368 10 5.625 10H9C9.62132 10 10.125 9.50254 10.125 8.88889C10.125 8.27524 9.62132 7.77778 9 7.77778H5.625Z"
                fill="#555454"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18 16.6667C18 18.5076 16.489 20 14.625 20H3.375C1.51104 20 0 18.5076 0 16.6667V3.33333C0 1.49238 1.51104 0 3.375 0H11.443C12.3381 0 13.1966 0.35119 13.8295 0.976311L17.0115 4.11901C17.6444 4.74413 18 5.59198 18 6.47603V16.6667ZM2.25 3.33333C2.25 2.71968 2.75368 2.22222 3.375 2.22222H10.125V4.44444C10.125 6.28539 11.636 7.77778 13.5 7.77778H15.75V16.6667C15.75 17.2803 15.2463 17.7778 14.625 17.7778H3.375C2.75368 17.7778 2.25 17.2803 2.25 16.6667V3.33333ZM15.284 5.55556H13.5C12.8787 5.55556 12.375 5.05809 12.375 4.44444V2.68246L15.284 5.55556Z"
                fill="#555454"
            />
        </svg>
    );
};

export const AsideVacancyIcon = () => {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 0C5.79086 0 4 1.79086 4 4C4 6.20914 5.79086 8 8 8C10.2091 8 12 6.20914 12 4C12 1.79086 10.2091 0 8 0ZM6 4C6 2.89543 6.89543 2 8 2C9.10457 2 10 2.89543 10 4C10 5.10457 9.10457 6 8 6C6.89543 6 6 5.10457 6 4Z"
                fill="#555454"
            />
            <path
                d="M2 17C2 13.6863 4.68629 11 8 11C11.3137 11 14 13.6863 14 17C14 17.5523 14.4477 18 15 18C15.5523 18 16 17.5523 16 17C16 12.5817 12.4183 9 8 9C3.58172 9 0 12.5817 0 17C0 17.5523 0.447715 18 1 18C1.55228 18 2 17.5523 2 17Z"
                fill="#555454"
            />
            <path
                d="M15 5C15.5523 5 16 5.44772 16 6V7H17C17.5523 7 18 7.44772 18 8C18 8.55229 17.5523 9 17 9H16V10C16 10.5523 15.5523 11 15 11C14.4477 11 14 10.5523 14 10V9H13C12.4477 9 12 8.55228 12 8C12 7.44771 12.4477 7 13 7H14V6C14 5.44772 14.4477 5 15 5Z"
                fill="#555454"
            />
        </svg>
    );
};

export const AsideFeedbackIcon = () => {
    return (
        <svg
            width="18"
            height="21"
            viewBox="0 0 18 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6.86914 16.1055V17.7839C6.86914 18.7071 7.62369 19.4624 8.54591 19.4624C9.46814 19.4624 10.2227 18.7071 10.2227 17.7839V16.1055"
                stroke="#555454"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1 16.1055H16.091"
                stroke="#555454"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1 16.1062C2.67677 15.2669 2.67677 13.6724 2.67677 12.7492V8.7965C2.67677 5.58226 5.15002 2.77086 8.36104 2.67854C11.681 2.57783 14.4142 5.24657 14.4142 8.55312V12.7492C14.4142 13.6724 14.4142 15.2669 16.091 16.1062"
                stroke="#555454"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.5459 2.67845V1"
                stroke="#555454"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const AsideEventsIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.9528 0.539449C10.752 0.204776 10.3903 0 10 0C9.60971 0 9.24803 0.204776 9.04723 0.539449L5.96679 5.67353L0.893221 6.68824C0.50439 6.76601 0.186472 7.0451 0.058998 7.42058C-0.0684765 7.79607 0.0138151 8.21103 0.274933 8.50945L3.81758 12.5582L2.79291 18.7062C2.72542 19.1112 2.88671 19.5203 3.21236 19.7703C3.53801 20.0202 3.97495 20.0703 4.34868 19.9004L10 17.3316L15.6513 19.9004C16.025 20.0703 16.462 20.0202 16.7876 19.7703C17.1133 19.5203 17.2746 19.1112 17.2071 18.7062L16.1824 12.5582L19.7251 8.50945C19.9862 8.21103 20.0685 7.79607 19.941 7.42058C19.8135 7.0451 19.4956 6.76601 19.1068 6.68824L14.0332 5.67353L10.9528 0.539449ZM7.61944 7.23833L10 3.27072L12.3806 7.23833C12.5416 7.50676 12.8085 7.6948 13.1154 7.7562L16.7885 8.49082L14.1638 11.4905C13.9446 11.741 13.8493 12.0766 13.904 12.4049L14.6722 17.0143L10.4598 15.0996C10.1676 14.9668 9.83236 14.9668 9.54022 15.0996L5.32776 17.0143L6.096 12.4049C6.15072 12.0766 6.05538 11.741 5.8362 11.4905L3.21145 8.49082L6.88458 7.7562C7.19155 7.6948 7.45838 7.50676 7.61944 7.23833Z"
                fill="#555454"
            />
        </svg>
    );
};

export const AsideCoursesIcon = () => {
    return (
        <svg
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.9685 0.878679C14.1401 -0.292894 16.0396 -0.292892 17.2112 0.87868C18.3827 2.05025 18.3827 3.94975 17.2112 5.12132L12.0316 10.3009C11.851 10.4815 11.608 10.5862 11.3526 10.5934L8.44234 10.6752C8.16724 10.683 7.90112 10.577 7.70665 10.3823C7.51218 10.1876 7.40655 9.92129 7.41465 9.64621L7.50043 6.73199C7.50794 6.47707 7.61256 6.23465 7.79289 6.05431L12.9685 0.878679ZM15.797 2.29289C15.4064 1.90237 14.7733 1.90237 14.3827 2.29289L14.1951 2.4805L15.6093 3.89472L15.797 3.70711C16.1875 3.31658 16.1875 2.68342 15.797 2.29289ZM14.1951 5.30893L12.7809 3.89472L9.48788 7.18775L9.44495 8.64624L10.8987 8.60534L14.1951 5.30893Z"
                fill="#555454"
            />
            <path
                d="M3 2.17157C2.44772 2.17157 2 2.61929 2 3.17157V15.1716C2 15.7239 2.44772 16.1716 3 16.1716H15C15.5523 16.1716 16 15.7239 16 15.1716V9.17157C16 8.61929 16.4477 8.17157 17 8.17157C17.5523 8.17157 18 8.61929 18 9.17157V15.1716C18 16.8284 16.6569 18.1716 15 18.1716H3C1.34315 18.1716 0 16.8284 0 15.1716V3.17157C0 1.51472 1.34315 0.171573 3 0.171573H9C9.55229 0.171573 10 0.619289 10 1.17157C10 1.72386 9.55229 2.17157 9 2.17157H3Z"
                fill="#555454"
            />
        </svg>
    );
};

export const AsideTestsIcon = () => {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.20711 9.52396C9.59764 9.13344 9.59764 8.50027 9.20711 8.10975C8.81659 7.71922 8.18342 7.71922 7.7929 8.10975L5.2929 10.6097C4.90238 11.0003 4.90238 11.6334 5.2929 12.024C5.68342 12.4145 6.31659 12.4145 6.70711 12.024L9.20711 9.52396Z"
                fill="#555454"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.6667 0.880426C11.838 -0.292793 13.7388 -0.293575 14.9111 0.87868L16.326 2.29357C17.4965 3.46407 17.4977 5.36142 16.3287 6.53344L7.16009 15.7261C6.71906 16.1682 6.15102 16.4618 5.5352 16.5657L1.16641 17.3029C0.857857 17.355 0.542723 17.2596 0.314811 17.0452C0.0868989 16.8308 -0.0275119 16.5221 0.0056332 16.2109L0.448242 12.056C0.520804 11.3748 0.824306 10.739 1.3083 10.2542L10.6667 0.880426ZM13.4969 2.29289C13.1061 1.90214 12.4725 1.9024 12.0821 2.29348L10.6696 3.70826L13.4994 6.53805L14.9127 5.12108C15.3023 4.7304 15.3019 4.09795 14.9117 3.70779L13.4969 2.29289ZM2.72367 11.6673L9.25655 5.12364L12.087 7.95411L5.74403 14.3137C5.59702 14.4611 5.40767 14.5589 5.2024 14.5936L2.13408 15.1113L2.43699 12.2679C2.46118 12.0408 2.56234 11.8289 2.72367 11.6673Z"
                fill="#555454"
            />
        </svg>
    );
};

export const AsideNewsIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10ZM2.06189 11C2.39999 13.7113 4.09485 16.0013 6.44561 17.169C6.38064 17.0388 6.31802 16.9057 6.25776 16.7701C5.56798 15.2181 5.12643 13.204 5.02328 11H2.06189ZM5.02328 9H2.06189C2.39999 6.2887 4.09485 3.99874 6.44561 2.83099C6.38064 2.96122 6.31802 3.09431 6.25776 3.2299C5.56798 4.78191 5.12643 6.79597 5.02328 9ZM7.02567 11C7.12736 12.9665 7.52392 14.6945 8.08538 15.9578C8.41337 16.6958 8.77801 17.2311 9.1324 17.5683C9.48164 17.9007 9.7731 18 10 18C10.2269 18 10.5184 17.9007 10.8676 17.5683C11.222 17.2311 11.5866 16.6958 11.9146 15.9578C12.4761 14.6945 12.8726 12.9665 12.9743 11H7.02567ZM12.9743 9H7.02567C7.12736 7.03347 7.52392 5.30546 8.08538 4.04218C8.41337 3.30422 8.77801 2.76892 9.1324 2.43166C9.48164 2.0993 9.7731 2 10 2C10.2269 2 10.5184 2.0993 10.8676 2.43166C11.222 2.76892 11.5866 3.30422 11.9146 4.04218C12.4761 5.30546 12.8726 7.03347 12.9743 9ZM14.9767 11C14.8736 13.204 14.432 15.2181 13.7422 16.7701C13.682 16.9057 13.6194 17.0388 13.5544 17.169C15.9052 16.0013 17.6 13.7113 17.9381 11H14.9767ZM17.9381 9H14.9767C14.8736 6.79597 14.432 4.78191 13.7422 3.2299C13.682 3.09431 13.6194 2.96122 13.5544 2.83099C15.9052 3.99874 17.6 6.2887 17.9381 9Z"
                fill="#555454"
            />
        </svg>
    );
};

export const AddButton = () => {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.8 6.6L6.6 6.6L6.6 7.8C6.6 8.13137 6.33137 8.4 6 8.4C5.66863 8.4 5.4 8.13137 5.4 7.8L5.4 6.6L4.2 6.6C3.86863 6.6 3.6 6.33137 3.6 6C3.6 5.66863 3.86863 5.4 4.2 5.4L5.4 5.4L5.4 4.2C5.4 3.86863 5.66863 3.6 6 3.6C6.33137 3.6 6.6 3.86863 6.6 4.2L6.6 5.4L7.8 5.4C8.13137 5.4 8.4 5.66863 8.4 6C8.4 6.33137 8.13137 6.6 7.8 6.6Z"
                fill="#11139F"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M-2.62268e-07 6C-1.17422e-07 9.31371 2.68629 12 6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 3.08141e-07 6 4.52987e-07C2.68629 5.97834e-07 -4.07115e-07 2.68629 -2.62268e-07 6ZM6 10.8C3.34903 10.8 1.2 8.65097 1.2 6C1.2 3.34903 3.34903 1.2 6 1.2C8.65097 1.2 10.8 3.34903 10.8 6C10.8 8.65097 8.65097 10.8 6 10.8Z"
                fill="#11139F"
            />
        </svg>
    );
};

export const CrossButton = ({ className, onClick }: ActiveButtonProps) => {
    return (
        <svg
            onClick={onClick}
            className={className}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1.70711 0.292893C1.31658 -0.0976311 0.683417 -0.0976311 0.292893 0.292893C-0.0976311 0.683417 -0.0976311 1.31658 0.292893 1.70711L6.58579 8L0.292893 14.2929C-0.0976311 14.6834 -0.0976311 15.3166 0.292893 15.7071C0.683417 16.0976 1.31658 16.0976 1.70711 15.7071L8 9.41421L14.2929 15.7071C14.6834 16.0976 15.3166 16.0976 15.7071 15.7071C16.0976 15.3166 16.0976 14.6834 15.7071 14.2929L9.41421 8L15.7071 1.70711C16.0976 1.31658 16.0976 0.683417 15.7071 0.292893C15.3166 -0.0976311 14.6834 -0.0976311 14.2929 0.292893L8 6.58579L1.70711 0.292893Z"
                fill="#555454"
            />
        </svg>
    );
};

interface ActiveButtonProps {
    onClick?: (event: React.MouseEvent<HTMLOrSVGElement>) => void;
    className?: string;
}

export const MyProfileIcon = () => {
    return (
        <svg
            width="16"
            height="15"
            viewBox="0 0 16 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="path-1-outside-1_187_185"
                maskUnits="userSpaceOnUse"
                x="0"
                y="-0.625"
                width="16"
                height="16"
                fill="black"
            >
                <rect fill="white" y="-0.625" width="16" height="16" />
                <path d="M8.125 7.5C9.06983 7.5 9.97597 7.12467 10.6441 6.45657C11.3122 5.78847 11.6875 4.88233 11.6875 3.9375C11.6875 2.99267 11.3122 2.08653 10.6441 1.41843C9.97597 0.750334 9.06983 0.375 8.125 0.375C7.18017 0.375 6.27403 0.750334 5.60593 1.41843C4.93783 2.08653 4.5625 2.99267 4.5625 3.9375C4.5625 4.88233 4.93783 5.78847 5.60593 6.45657C6.27403 7.12467 7.18017 7.5 8.125 7.5ZM10.5 3.9375C10.5 4.56739 10.2498 5.17148 9.80438 5.61688C9.35898 6.06228 8.75489 6.3125 8.125 6.3125C7.49511 6.3125 6.89102 6.06228 6.44562 5.61688C6.00022 5.17148 5.75 4.56739 5.75 3.9375C5.75 3.30761 6.00022 2.70352 6.44562 2.25812C6.89102 1.81272 7.49511 1.5625 8.125 1.5625C8.75489 1.5625 9.35898 1.81272 9.80438 2.25812C10.2498 2.70352 10.5 3.30761 10.5 3.9375ZM15.25 13.4375C15.25 14.625 14.0625 14.625 14.0625 14.625H2.1875C2.1875 14.625 1 14.625 1 13.4375C1 12.25 2.1875 8.6875 8.125 8.6875C14.0625 8.6875 15.25 12.25 15.25 13.4375ZM14.0625 13.4328C14.0613 13.1406 13.8796 12.2619 13.0745 11.4567C12.3003 10.6825 10.8432 9.875 8.125 9.875C5.40562 9.875 3.94975 10.6825 3.1755 11.4567C2.37038 12.2619 2.18988 13.1406 2.1875 13.4328H14.0625Z" />
            </mask>
            <path
                d="M8.125 7.5C9.06983 7.5 9.97597 7.12467 10.6441 6.45657C11.3122 5.78847 11.6875 4.88233 11.6875 3.9375C11.6875 2.99267 11.3122 2.08653 10.6441 1.41843C9.97597 0.750334 9.06983 0.375 8.125 0.375C7.18017 0.375 6.27403 0.750334 5.60593 1.41843C4.93783 2.08653 4.5625 2.99267 4.5625 3.9375C4.5625 4.88233 4.93783 5.78847 5.60593 6.45657C6.27403 7.12467 7.18017 7.5 8.125 7.5ZM10.5 3.9375C10.5 4.56739 10.2498 5.17148 9.80438 5.61688C9.35898 6.06228 8.75489 6.3125 8.125 6.3125C7.49511 6.3125 6.89102 6.06228 6.44562 5.61688C6.00022 5.17148 5.75 4.56739 5.75 3.9375C5.75 3.30761 6.00022 2.70352 6.44562 2.25812C6.89102 1.81272 7.49511 1.5625 8.125 1.5625C8.75489 1.5625 9.35898 1.81272 9.80438 2.25812C10.2498 2.70352 10.5 3.30761 10.5 3.9375ZM15.25 13.4375C15.25 14.625 14.0625 14.625 14.0625 14.625H2.1875C2.1875 14.625 1 14.625 1 13.4375C1 12.25 2.1875 8.6875 8.125 8.6875C14.0625 8.6875 15.25 12.25 15.25 13.4375ZM14.0625 13.4328C14.0613 13.1406 13.8796 12.2619 13.0745 11.4567C12.3003 10.6825 10.8432 9.875 8.125 9.875C5.40562 9.875 3.94975 10.6825 3.1755 11.4567C2.37038 12.2619 2.18988 13.1406 2.1875 13.4328H14.0625Z"
                fill="#555454"
            />
            <path
                d="M8.125 7.5V7.7V7.5ZM8.125 0.375V0.175V0.375ZM10.5 3.9375H10.3H10.5ZM8.125 6.3125V6.5125V6.3125ZM5.75 3.9375H5.55H5.75ZM8.125 1.5625V1.3625V1.5625ZM14.0625 13.4328V13.6328H14.2633L14.2625 13.4319L14.0625 13.4328ZM2.1875 13.4328L1.98751 13.4311L1.98587 13.6328H2.1875V13.4328ZM8.125 7.7C9.12288 7.7 10.0799 7.30359 10.7855 6.59799L10.5026 6.31515C9.87206 6.94574 9.01679 7.3 8.125 7.3V7.7ZM10.7855 6.59799C11.4911 5.89238 11.8875 4.93538 11.8875 3.9375H11.4875C11.4875 4.82929 11.1332 5.68456 10.5026 6.31515L10.7855 6.59799ZM11.8875 3.9375C11.8875 2.93962 11.4911 1.98262 10.7855 1.27701L10.5026 1.55985C11.1332 2.19044 11.4875 3.04571 11.4875 3.9375H11.8875ZM10.7855 1.27701C10.0799 0.571405 9.12288 0.175 8.125 0.175V0.575C9.01679 0.575 9.87206 0.929263 10.5026 1.55985L10.7855 1.27701ZM8.125 0.175C7.12712 0.175 6.17012 0.571405 5.46451 1.27701L5.74735 1.55985C6.37794 0.929262 7.23321 0.575 8.125 0.575V0.175ZM5.46451 1.27701C4.75891 1.98262 4.3625 2.93962 4.3625 3.9375H4.7625C4.7625 3.04571 5.11676 2.19044 5.74735 1.55985L5.46451 1.27701ZM4.3625 3.9375C4.3625 4.93538 4.75891 5.89238 5.46451 6.59799L5.74735 6.31515C5.11676 5.68456 4.7625 4.82929 4.7625 3.9375H4.3625ZM5.46451 6.59799C6.17012 7.30359 7.12712 7.7 8.125 7.7V7.3C7.23321 7.3 6.37794 6.94574 5.74735 6.31515L5.46451 6.59799ZM10.3 3.9375C10.3 4.51435 10.0708 5.06757 9.66296 5.47546L9.9458 5.7583C10.4287 5.27539 10.7 4.62043 10.7 3.9375H10.3ZM9.66296 5.47546C9.25506 5.88335 8.70185 6.1125 8.125 6.1125V6.5125C8.80793 6.5125 9.46289 6.24121 9.9458 5.7583L9.66296 5.47546ZM8.125 6.1125C7.54815 6.1125 6.99493 5.88335 6.58704 5.47546L6.3042 5.7583C6.78711 6.24121 7.44207 6.5125 8.125 6.5125V6.1125ZM6.58704 5.47546C6.17915 5.06757 5.95 4.51435 5.95 3.9375H5.55C5.55 4.62043 5.82129 5.27539 6.3042 5.7583L6.58704 5.47546ZM5.95 3.9375C5.95 3.36065 6.17915 2.80743 6.58704 2.39954L6.3042 2.1167C5.82129 2.59961 5.55 3.25457 5.55 3.9375H5.95ZM6.58704 2.39954C6.99493 1.99165 7.54815 1.7625 8.125 1.7625V1.3625C7.44207 1.3625 6.78711 1.63379 6.3042 2.1167L6.58704 2.39954ZM8.125 1.7625C8.70185 1.7625 9.25506 1.99165 9.66296 2.39954L9.9458 2.1167C9.46289 1.63379 8.80793 1.3625 8.125 1.3625V1.7625ZM9.66296 2.39954C10.0708 2.80743 10.3 3.36065 10.3 3.9375H10.7C10.7 3.25457 10.4287 2.59961 9.9458 2.1167L9.66296 2.39954ZM15.05 13.4375C15.05 13.6994 14.9851 13.8825 14.898 14.0131C14.8101 14.1449 14.6915 14.2353 14.5668 14.2977C14.4413 14.3604 14.3134 14.3928 14.2152 14.4092C14.1665 14.4173 14.1264 14.4212 14.0993 14.4232C14.0857 14.4242 14.0755 14.4246 14.0692 14.4248C14.066 14.4249 14.0638 14.425 14.0627 14.425C14.0621 14.425 14.0618 14.425 14.0618 14.425C14.0618 14.425 14.0618 14.425 14.0619 14.425C14.062 14.425 14.0621 14.425 14.0622 14.425C14.0622 14.425 14.0623 14.425 14.0623 14.425C14.0624 14.425 14.0625 14.425 14.0625 14.625C14.0625 14.825 14.0626 14.825 14.0627 14.825C14.0628 14.825 14.0629 14.825 14.0629 14.825C14.0631 14.825 14.0633 14.825 14.0635 14.825C14.0639 14.825 14.0644 14.825 14.0649 14.825C14.0661 14.825 14.0675 14.825 14.0691 14.8249C14.0725 14.8249 14.077 14.8248 14.0825 14.8246C14.0936 14.8242 14.1088 14.8235 14.1278 14.8222C14.1656 14.8195 14.2182 14.8142 14.2809 14.8037C14.4054 14.783 14.5743 14.7411 14.7457 14.6554C14.9179 14.5694 15.0961 14.4371 15.2309 14.235C15.3665 14.0316 15.45 13.7694 15.45 13.4375H15.05ZM14.0625 14.425H2.1875V14.825H14.0625V14.425ZM2.1875 14.625C2.1875 14.425 2.18759 14.425 2.18768 14.425C2.18771 14.425 2.18779 14.425 2.18784 14.425C2.18793 14.425 2.18801 14.425 2.18807 14.425C2.18819 14.425 2.18824 14.425 2.18823 14.425C2.18819 14.425 2.18789 14.425 2.18732 14.425C2.18618 14.425 2.18399 14.4249 2.18083 14.4248C2.17449 14.4246 2.16427 14.4242 2.15072 14.4232C2.12357 14.4212 2.08347 14.4173 2.03483 14.4092C1.9366 14.3928 1.80869 14.3604 1.68319 14.2977C1.55848 14.2353 1.43985 14.1449 1.35196 14.0131C1.26489 13.8825 1.2 13.6994 1.2 13.4375H0.8C0.8 13.7694 0.883543 14.0316 1.01914 14.235C1.1539 14.4371 1.33214 14.5694 1.50431 14.6554C1.67569 14.7411 1.84465 14.783 1.96907 14.8037C2.03176 14.8142 2.08444 14.8195 2.12223 14.8222C2.14115 14.8235 2.15644 14.8242 2.1675 14.8246C2.17303 14.8248 2.17751 14.8249 2.18087 14.8249C2.18255 14.825 2.18394 14.825 2.18505 14.825C2.18561 14.825 2.18609 14.825 2.1865 14.825C2.1867 14.825 2.18689 14.825 2.18705 14.825C2.18714 14.825 2.18725 14.825 2.18729 14.825C2.1874 14.825 2.1875 14.825 2.1875 14.625ZM1.2 13.4375C1.2 12.8951 1.47698 11.759 2.47736 10.7586C3.47187 9.7641 5.19843 8.8875 8.125 8.8875V8.4875C5.11407 8.4875 3.27813 9.39215 2.19452 10.4758C1.11677 11.5535 0.8 12.7924 0.8 13.4375H1.2ZM8.125 8.8875C11.0516 8.8875 12.7781 9.7641 13.7726 10.7586C14.773 11.759 15.05 12.8951 15.05 13.4375H15.45C15.45 12.7924 15.1332 11.5535 14.0555 10.4758C12.9719 9.39215 11.1359 8.4875 8.125 8.4875V8.8875ZM14.2625 13.4319C14.2611 13.0888 14.0595 12.1589 13.2159 11.3153L12.9331 11.5982C13.6997 12.3648 13.8615 13.1925 13.8625 13.4336L14.2625 13.4319ZM13.2159 11.3153C12.3972 10.4966 10.8855 9.675 8.125 9.675V10.075C10.8009 10.075 12.2033 10.8684 12.9331 11.5982L13.2159 11.3153ZM8.125 9.675C5.36332 9.675 3.8528 10.4966 3.03408 11.3153L3.31692 11.5982C4.0467 10.8684 5.44793 10.075 8.125 10.075V9.675ZM3.03408 11.3153C2.19018 12.1592 1.99029 13.0889 1.98751 13.4311L2.38749 13.4344C2.38946 13.1923 2.55057 12.3645 3.31692 11.5982L3.03408 11.3153ZM2.1875 13.6328H14.0625V13.2327H2.1875V13.6328Z"
                fill="#555454"
                mask="url(#path-1-outside-1_187_185)"
            />
        </svg>
    );
};

export const QuitIcon = () => {
    return (
        <svg
            width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6.66666 0C8.04737 0 9.16665 1.11929 9.16665 2.5V3.33333C9.16665 3.79357 8.79356 4.16667 8.33332 4.16667C7.87308 4.16667 7.49999 3.79357 7.49999 3.33333V2.5C7.49999 2.03976 7.12689 1.66667 6.66666 1.66667H2.5C2.03976 1.66667 1.66666 2.03976 1.66666 2.5V12.5C1.66666 12.9602 2.03976 13.3333 2.5 13.3333H6.66666C7.12689 13.3333 7.49999 12.9602 7.49999 12.5V11.6667C7.49999 11.2064 7.87308 10.8333 8.33332 10.8333C8.79356 10.8333 9.16665 11.2064 9.16665 11.6667V12.5C9.16665 13.8807 8.04737 15 6.66666 15H2.5C1.11929 15 0 13.8807 0 12.5V2.5C0 1.11929 1.11929 0 2.5 0H6.66666Z"
                fill="#555454"
            />
            <path
                d="M11.4226 3.57741C11.0971 3.25197 10.5695 3.25197 10.2441 3.57741C9.91862 3.90285 9.91862 4.43049 10.2441 4.75592L12.1548 6.66667H4.16666C3.70642 6.66667 3.33333 7.03976 3.33333 7.5C3.33333 7.96024 3.70642 8.33333 4.16666 8.33333H12.1548L10.2441 10.2441C9.91862 10.5695 9.91862 11.0972 10.2441 11.4226C10.5695 11.748 11.0971 11.748 11.4226 11.4226L14.7559 8.08926C14.9043 7.94086 14.985 7.75041 14.9981 7.55627C15.0018 7.50187 15.0001 7.44697 14.993 7.39235C14.9726 7.23465 14.9071 7.08167 14.7965 6.95428C14.7821 6.9377 14.7671 6.92173 14.7515 6.90639L11.4226 3.57741Z"
                fill="#555454"
            />
        </svg>
    );
};

export const HidePasswordIcon = ({ onClick }: ActiveButtonProps) => {
    return (
        <svg
            width="20"
            height="10"
            viewBox="0 0 20 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M19.6469 6.26262C19.7457 6.43433 19.7726 6.63816 19.7217 6.82962C19.6707 7.02108 19.5461 7.18461 19.375 7.2845C19.262 7.35298 19.1321 7.38869 19 7.38762C18.8672 7.38881 18.7365 7.35472 18.6212 7.28883C18.5059 7.22295 18.4101 7.12763 18.3437 7.01262L16.6187 4.03137C15.6066 4.71223 14.4927 5.22802 13.3187 5.5595L13.8625 8.64387C13.8954 8.84005 13.8499 9.04129 13.736 9.20433C13.622 9.36737 13.4486 9.47919 13.2531 9.51575H13.1219C12.9453 9.51626 12.7743 9.4545 12.6388 9.34132C12.5033 9.22814 12.4121 9.0708 12.3812 8.897L11.8469 5.8595C11.2354 5.95066 10.6182 5.99766 10 6.00012C9.37892 6.00041 8.75861 5.95655 8.14375 5.86887L7.60937 8.90637C7.57848 9.08018 7.48727 9.23751 7.3518 9.35069C7.21633 9.46387 7.04527 9.52564 6.86875 9.52512H6.7375C6.54197 9.48856 6.3686 9.37675 6.25465 9.21371C6.1407 9.05067 6.09526 8.84943 6.12812 8.65325L6.68125 5.5595C5.50358 5.23016 4.38629 4.71424 3.37187 4.03137L1.6375 7.03137C1.5705 7.14376 1.47592 7.23719 1.36272 7.30281C1.24952 7.36844 1.12145 7.40408 0.990622 7.40637C0.859194 7.40591 0.730195 7.37092 0.616548 7.3049C0.502901 7.23889 0.408597 7.14417 0.343084 7.03023C0.27757 6.91629 0.243147 6.78714 0.243264 6.65571C0.24338 6.52428 0.278032 6.39519 0.343747 6.28137L2.17187 3.11262C1.53304 2.56475 0.946174 1.95906 0.418747 1.30325C0.356417 1.22725 0.309837 1.13961 0.281722 1.04542C0.253608 0.951241 0.244522 0.852405 0.254993 0.754675C0.265464 0.656946 0.295283 0.562278 0.342712 0.47619C0.390141 0.390101 0.454231 0.314314 0.531247 0.253247C0.606661 0.19039 0.693819 0.143155 0.787652 0.114287C0.881486 0.0854185 0.980123 0.0754935 1.07783 0.0850894C1.17553 0.0946853 1.27035 0.12361 1.35678 0.170183C1.4432 0.216755 1.5195 0.280045 1.58125 0.356372C2.16809 1.088 2.83824 1.74872 3.57812 2.32512H3.5875C5.4182 3.75318 7.67826 4.51976 10 4.50012C12.7469 4.50012 14.8562 3.5345 16.4031 2.3345H16.4219C17.1618 1.75809 17.8319 1.09738 18.4187 0.365747C18.4798 0.288731 18.5556 0.224641 18.6417 0.177211C18.7278 0.129782 18.8224 0.0999635 18.9202 0.0894925C19.0179 0.0790215 19.1167 0.088108 19.2109 0.116222C19.3051 0.144337 19.3927 0.190916 19.4687 0.253247C19.5458 0.314314 19.6099 0.390101 19.6573 0.47619C19.7047 0.562278 19.7345 0.656946 19.745 0.754675C19.7555 0.852405 19.7464 0.951241 19.7183 1.04542C19.6902 1.13961 19.6436 1.22725 19.5812 1.30325C19.0538 1.95906 18.467 2.56475 17.8281 3.11262L19.6469 6.26262Z"
                fill="#555454"
            />
        </svg>
    );
};

export const VisiblePasswordIcon = ({ onClick }: ActiveButtonProps) => {
    return (
        <svg
            onClick={onClick}
            width="22"
            height="18"
            viewBox="0 0 22 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.9997 0C16.3917 0 20.8777 3.88 21.8187 9C20.8787 14.12 16.3917 18 10.9997 18C5.60766 18 1.12166 14.12 0.180664 9C1.12066 3.88 5.60766 0 10.9997 0ZM10.9997 16C13.0391 15.9996 15.0181 15.3068 16.6125 14.0352C18.207 12.7635 19.3226 10.9883 19.7767 9C19.3209 7.0133 18.2046 5.24 16.6103 3.97003C15.016 2.70005 13.038 2.00853 10.9997 2.00853C8.96136 2.00853 6.98335 2.70005 5.38904 3.97003C3.79473 5.24 2.67843 7.0133 2.22266 9C2.67676 10.9883 3.79234 12.7635 5.38681 14.0352C6.98128 15.3068 8.9602 15.9996 10.9997 16ZM10.9997 13.5C9.80619 13.5 8.6616 13.0259 7.81768 12.182C6.97377 11.3381 6.49966 10.1935 6.49966 9C6.49966 7.80653 6.97377 6.66193 7.81768 5.81802C8.6616 4.97411 9.80619 4.5 10.9997 4.5C12.1931 4.5 13.3377 4.97411 14.1816 5.81802C15.0256 6.66193 15.4997 7.80653 15.4997 9C15.4997 10.1935 15.0256 11.3381 14.1816 12.182C13.3377 13.0259 12.1931 13.5 10.9997 13.5ZM10.9997 11.5C11.6627 11.5 12.2986 11.2366 12.7674 10.7678C13.2363 10.2989 13.4997 9.66304 13.4997 9C13.4997 8.33696 13.2363 7.70107 12.7674 7.23223C12.2986 6.76339 11.6627 6.5 10.9997 6.5C10.3366 6.5 9.70074 6.76339 9.2319 7.23223C8.76306 7.70107 8.49966 8.33696 8.49966 9C8.49966 9.66304 8.76306 10.2989 9.2319 10.7678C9.70074 11.2366 10.3366 11.5 10.9997 11.5Z"
                fill="#555454"
            />
        </svg>
    );
};

export const AddPinIcon = ({ onClick, className }: ActiveButtonProps) => {
    return (
        <svg
            onClick={onClick}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="20"
            viewBox="0 0 12 20"
            fill="none"
        >
            <path
                d="M4.5 0C2.01472 0 3.99351e-06 2.01472 4.05312e-06 4.5L0 14C0 17.3137 2.68629 20 6 20C9.31371 20 12 17.3137 12 14V11C12 10.4477 11.5523 10 11 10C10.4477 10 10 10.4477 10 11V14C10 16.2091 8.20914 18 6 18C3.79086 18 2 16.2091 2 14L2 4.5C2 3.11929 3.11929 2 4.5 2C5.88072 2 7 3.11929 7 4.5L7 11.8277C7 12.3799 6.55228 12.8277 6 12.8277C5.44772 12.8277 5 12.3799 5 11.8277V6.77083C5 6.21854 4.55228 5.77083 4 5.77083C3.44772 5.77083 3 6.21854 3 6.77083L3 11.8277C3 13.4845 4.34314 14.8277 6 14.8277C7.65685 14.8277 9 13.4845 9 11.8277L9 4.5C9 2.01472 6.98528 0 4.5 0Z"
                fill="#555454"
            />
        </svg>
    );
};

export const EditIcon = ({ className, onClick }: ActiveButtonProps) => {
    return (
        <svg
            className={className}
            onClick={onClick}
            fill="none"
            height="24"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
        </svg>
    );
};

export const ConfirmIcon = ({
    className,
    onClick,
    isDisabled,
    availableClassName,
}: ConfirmIconProps) => {
    return (
        <svg
            className={cn(className, {
                [String(availableClassName)]: !isDisabled,
            })}
            onClick={() => {
                onClick && onClick();
            }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24px"
            height="24px"
        >
            <path d="M 12 2 C 6.486 2 2 6.486 2 12 C 2 17.514 6.486 22 12 22 C 17.514 22 22 17.514 22 12 C 22 10.874 21.803984 9.7942031 21.458984 8.7832031 L 19.839844 10.402344 C 19.944844 10.918344 20 11.453 20 12 C 20 16.411 16.411 20 12 20 C 7.589 20 4 16.411 4 12 C 4 7.589 7.589 4 12 4 C 13.633 4 15.151922 4.4938906 16.419922 5.3378906 L 17.851562 3.90625 C 16.203562 2.71225 14.185 2 12 2 z M 21.292969 3.2929688 L 11 13.585938 L 7.7070312 10.292969 L 6.2929688 11.707031 L 11 16.414062 L 22.707031 4.7070312 L 21.292969 3.2929688 z" />
        </svg>
    );
};

interface ConfirmIconProps {
    className?: string;
    onClick?: () => void;
    isDisabled?: boolean;
    availableClassName?: string;
}

export const EditAvatarIcon = ({ className, onClick }: ActiveButtonProps) => {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16.0218 6.12555L11.951 2.10265L13.292 0.76169C13.6592 0.394522 14.1103 0.210938 14.6454 0.210938C15.1799 0.210938 15.6307 0.394522 15.9979 0.76169L17.3388 2.10265C17.706 2.46982 17.8976 2.91298 17.9135 3.43212C17.9295 3.95063 17.7539 4.39347 17.3867 4.76064L16.0218 6.12555ZM14.633 7.53835L4.47996 17.6914H0.40918V13.6206L10.5622 3.46756L14.633 7.53835Z"
                fill="#555454"
            />
        </svg>
    );
};

export const KeydownArrow = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="56"
            height="62"
            viewBox="0 0 56 62"
            fill="none"
        >
            <path
                d="M29 36C28.7848 36 28.5765 35.958 28.3752 35.874C28.1729 35.7901 28.0045 35.6781 27.87 35.5382L20.4439 27.813C20.148 27.5051 20 27.1132 20 26.6374C20 26.1616 20.148 25.7697 20.4439 25.4618C20.7399 25.1539 21.1166 25 21.574 25C22.0314 25 22.4081 25.1539 22.704 25.4618L29 32.0115L35.296 25.4618C35.5919 25.1539 35.9686 25 36.426 25C36.8834 25 37.2601 25.1539 37.5561 25.4618C37.852 25.7697 38 26.1616 38 26.6374C38 27.1132 37.852 27.5051 37.5561 27.813L30.13 35.5382C29.9686 35.7061 29.7937 35.8248 29.6054 35.8942C29.417 35.9647 29.2152 36 29 36Z"
                fill="#555454"
            />
        </svg>
    );
};
export const CloseIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="17"
            viewBox="0 0 12 17"
            fill="none"
        >
            <path
                d="M3 12L8 7M8 12L3 7"
                stroke="#979797"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
